import FieldSection from '../enums/FieldSection'

export interface FieldSectionDefinition {
  key: FieldSection
  label: string
  description: string
  order: number
}

export const FIELD_SECTIONS: FieldSectionDefinition[] = [
  {
    key: FieldSection.STANDARD_DATA,
    label: 'Standarddata',
    description: 'Fält som skapar värde ur ett analysperspektiv',
    order: 1
  },
  {
    key: FieldSection.LOCATION,
    label: 'Plats',
    description: 'Fält som beskriver den geografiska positionen av raden.',
    order: 2
  },
  {
    key: FieldSection.IDS_AND_RELATIONS,
    label: 'ID:n & Relationer',
    description: 'Fält som binder ihop rader men bär ingen egen mening.',
    order: 3
  },
  {
    key: FieldSection.CUSTOMER_SPECIFIC,
    label: 'Kundspecifika',
    description:
      'Flexibla fält där kunden kan komplettera modellen med egen data.',
    order: 4
  },
  {
    key: FieldSection.SOURCE_LINK,
    label: 'Länk till källa',
    description: 'Navigering till motsvarande rad i källsystemet.',
    order: 5
  },
  {
    key: FieldSection.MULTI_CURRENCY,
    label: 'Valutaomvandling',
    description:
      'Stöd för kunder med verksamhet i flera länder som behöver ' +
      'konvertera mellan valutor.',
    order: 6
  }
]

export const DEPRECATED_GROUP = {
  label: 'Utfasade',
  description:
    'Fält som finns kvar men inte ska populeras på nytt. ' +
    'Planen är att de ska plockas bort.',
  order: 99
}
